<template>
    <th class="!p-0 h-9">
        <div class="flex relative items-center h-full">
            <span class="grow pl-5 pr-1">{{ $t("Global.Stock") }}</span>
            <button class="w-10 bg-gray-500 h-full" :class="{ active: hasNotification }" :title="title" @click="click">
                <i class="fas fa-plus-sign" />
                <i class="fas fa-bell" />
            </button>
        </div>
    </th>
</template>

<script setup lang="ts">
const { t } = useI18n();
const { gtag } = useGtag();
const isNotificationOpen = useStateNotificationIsOpen();

const props = defineProps({ notification: { type: Object, default: null } });

const partNumber = ref<string>(props.notification?.Part?.PartNumber);

const hasNotification = computed(() => {
    return props.notification?.PriceAlerts?.length > 0 || props.notification?.StockAlerts?.length > 0;
});

const title = computed(() => {
    return hasNotification.value ? t("Notifications.Watching") : t("Notifications.CreateProductNotification");
});

function click() {
    gtag("event", "Click Stock Header Icon", { event_category: "Stock and Price Alerts" });
    gtag("event", "alerts_open_modal_from_stock_header", { part_number: partNumber.value });
    isNotificationOpen.value = true;
}
</script>
